module.exports = __webpack_public_path__ + "img/vertical-yellow-line.716b909f.svg";